/* Bianca&Noe — punto V (2026-09-24): taglie su ordinazione.
   Una taglia e' "su ordinazione" quando ha l'inventario tracciato, "continua a vendere" e nessun pezzo
   pronto (tolti quelli gia' nel carrello). Qui:
   - pagina prodotto: riquadro "pronto" / "su ordinazione" con la data, suffisso nel menu delle taglie,
     proprieta' della riga accese solo per il pezzo da produrre, tetto di pezzi per taglia;
   - carrello: data sulla riga, avviso + casella obbligatoria prima del checkout, wallet nascosti,
     quantita' limitate (pezzi pronti = giacenza, pezzi da produrre = tetto) con una nota sotto la riga.
   Impostazioni e testi arrivano da snippets/bn-mto-config.liquid. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('BnMtoConfig');
  if (!cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  var MARK = '_bn_mto';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function fill(s, map) {
    return String(s).replace(/__([A-Z]+)__/g, function (m, k) { return k in map ? map[k] : m; });
  }

  /* ---------- data di spedizione: oggi + N giorni lavorativi ---------- */
  function day(y, m, d) { return new Date(y, m, d); }
  function next(d, n) { return day(d.getFullYear(), d.getMonth(), d.getDate() + n); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parseIso(s) { var p = s.split('-'); return day(+p[0], +p[1] - 1, +p[2]); }

  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return day(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
  }

  /* Festivita' nazionali italiane; il patrono locale e le ferie vanno fra le chiusure del tema. */
  var HOLIDAYS = {};
  function holiday(d) {
    var y = d.getFullYear();
    if (!HOLIDAYS[y]) {
      HOLIDAYS[y] = {};
      ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26']
        .forEach(function (md) { HOLIDAYS[y][y + '-' + md] = true; });
      HOLIDAYS[y][iso(next(easter(y), 1))] = true;
    }
    return HOLIDAYS[y][iso(d)];
  }

  var CLOSED = {};
  String(C.closures || '').split(/\r?\n/).forEach(function (line) {
    var m = line.trim().match(/^(\d{4}-\d{2}-\d{2})(?:\s*\.\.\s*(\d{4}-\d{2}-\d{2}))?$/);
    if (!m) return;
    for (var d = parseIso(m[1]), end = parseIso(m[2] || m[1]); d <= end; d = next(d, 1)) CLOSED[iso(d)] = true;
  });

  function working(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && !holiday(d) && !CLOSED[iso(d)];
  }

  /* Il giorno dell'ordine non conta: si parte dal primo giorno lavorativo successivo. */
  function shipBy() {
    var now = new Date(), d = day(now.getFullYear(), now.getMonth(), now.getDate()), n = C.days;
    while (n > 0) { d = next(d, 1); if (working(d)) n--; }
    return d;
  }

  function format(d) {
    try {
      return new Intl.DateTimeFormat(C.locale === 'it' ? 'it-IT' : 'en-GB',
        { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
    } catch (e) { return iso(d); }
  }

  var T = {};
  Object.keys(C.t).forEach(function (k) {
    T[k] = fill(C.t[k], { DATE: format(shipBy()), DAYS: C.days, CAP: C.cap });
  });

  /* ---------- carrello: pezzi gia' presenti per variante, pronti (r) e da produrre (m) ---------- */
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function isMto(item) { return !!(item.properties && item.properties[MARK]); }
  function countCart(cart) {
    var out = {};
    cart.items.forEach(function (it) {
      var k = String(it.variant_id);
      out[k] = out[k] || { r: 0, m: 0 };
      out[k][isMto(it) ? 'm' : 'r'] += it.quantity;
    });
    return out;
  }

  /* ---------- pagina prodotto ---------- */
  function initProduct(form) {
    var dataEl = form.querySelector('[data-bn-mto-variants]');
    if (!dataEl) return;
    var V = JSON.parse(dataEl.textContent);
    var box = form.querySelector('[data-bn-mto-message]');
    var props = form.querySelectorAll('[data-bn-mto-prop]');
    var idSelect = form.querySelector('[name="id"]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var selects = Array.prototype.slice.call(form.querySelectorAll('.single-option-selector'));
    var inCart = {};
    var bypass = false;

    function state(id) {
      var v = V[id];
      if (!v || !v.t) return 'none';
      if (v.q - (inCart[id] ? inCart[id].r : 0) > 0) return 'ready';
      if (v.m && C.enabled) {
        return C.cap > 0 && inCart[id] && inCart[id].m >= C.cap ? 'cap' : 'mto';
      }
      return v.m ? 'off' : 'none';   /* 'off' = su ordinazione ma interruttore spento */
    }

    function setProps(on) {
      for (var i = 0; i < props.length; i++) props[i].disabled = !on;
    }

    function variantFor(values) {
      for (var id in V) {
        if (V[id].o.every(function (x, j) { return x === values[j]; })) return id;
      }
      return null;
    }

    function annotateOptions() {
      selects.forEach(function (sel, idx) {
        if (sel.options.length < 2) return;
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (!opt.hasAttribute('data-bn-text')) opt.setAttribute('data-bn-text', opt.text);
          var values = selects.map(function (s, j) { return j === idx ? opt.value : s.value; });
          var id = variantFor(values);
          var st = id ? state(id) : 'none';
          opt.text = opt.getAttribute('data-bn-text') +
            (st === 'mto' || st === 'cap' ? ' — ' + T.option_suffix : '');
        });
      });
    }

    function lockButton(lock, text) {
      if (lock) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-bn-locked', '');
        if (text) buttonText.textContent = text;
      } else if (button.hasAttribute('data-bn-locked')) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-bn-locked');
        buttonText.textContent = T.add_to_cart;
      }
    }

    function update() {
      var st = state(idSelect.value);
      box.className = 'bn-mto' + (st === 'ready' ? ' bn-mto--ready' : '');
      if (st === 'ready') {
        box.innerHTML = '<p></p>';
        box.firstChild.textContent = T.ready;
      } else if (st === 'mto' || st === 'cap') {
        /* al limite la spiegazione resta: il messaggio sul tetto si aggiunge sotto */
        box.innerHTML = '<p class="bn-mto__title"></p><p></p>' + (st === 'cap' ? '<p class="bn-mto__limit"></p>' : '');
        box.children[0].textContent = T.title;
        box.children[1].textContent = T.body;
        if (st === 'cap') box.children[2].textContent = T.cap_reached;
      }
      box.hidden = !(st === 'ready' || st === 'mto' || st === 'cap');
      if (st === 'off') lockButton(true, T.sold_out);
      else if (st === 'cap') lockButton(true);
      else lockButton(false);
      annotateOptions();
    }

    function refresh() {
      return getCart().then(function (cart) { inCart = countCart(cart); update(); })
        .catch(function () { update(); });
    }

    /* Debut aggiorna la variante sullo stesso 'change': si ricalcola subito dopo. */
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () { setTimeout(update, 0); });
    });

    /* Prima del gestore ajax di Debut (fase di cattura sul document): si rilegge il carrello,
       si decide se il pezzo e' pronto o da produrre, poi si rimanda il submit. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (bypass) { bypass = false; return; }
      var id = idSelect.value;
      if (!V[id] || !V[id].m) { setProps(false); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      getCart().then(function (cart) { inCart = countCart(cart); }).catch(function () {})
        .then(function () {
          var st = state(id);
          if (st === 'off' || st === 'cap') { update(); return; }
          setProps(st === 'mto');
          bypass = true;
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
    }, true);

    /* Dopo ogni aggiunta al carrello (ajax di Debut, jQuery) si riconta. */
    if (window.jQuery) {
      jQuery(document).ajaxComplete(function (e, xhr, s) {
        if (s && /\/cart\/(add|change|update)/.test(s.url)) refresh();
      });
    }
    refresh();
  }

  /* ---------- carrello ---------- */
  function initCart(root) {
    var notice = root.querySelector('[data-bn-mto-cart]');
    if (!notice) return;
    var dataEl = document.getElementById('BnMtoCartVariants');
    var V = dataEl ? JSON.parse(dataEl.textContent) : {};
    var confirmBox = notice.querySelector('[data-bn-mto-confirm]');
    var error = notice.querySelector('[data-bn-mto-error]');
    var lines = root.querySelector('[data-cart-line-items]');
    var hasMto = false;

    notice.querySelector('[data-bn-mto-notice]').textContent = T.cart_notice;
    notice.querySelector('[data-bn-mto-confirm-text]').textContent = T.cart_confirm;
    confirmBox.addEventListener('change', function () { if (confirmBox.checked) error.hidden = true; });

    function apply(cart) {
      var byKey = {};
      hasMto = false;
      cart.items.forEach(function (it) { byKey[it.key] = it; if (isMto(it)) hasMto = true; });

      Array.prototype.forEach.call(root.querySelectorAll('[data-cart-item]'), function (row) {
        var it = byKey[row.getAttribute('data-cart-item-key')];
        if (!it) return;
        var mto = isMto(it);
        var line = row.querySelector('.bn-mto-line');
        if (mto && !line) {
          line = document.createElement('p');
          line.className = 'bn-mto-line';
          line.textContent = T.cart_line;
          var anchor = row.querySelector('[data-cart-item-details]') || row.querySelector('.list-view-item__title');
          if (anchor) anchor.insertAdjacentElement('afterend', line);
        } else if (!mto && line) {
          line.parentNode.removeChild(line);
        }
        /* pezzi da produrre: al massimo il tetto; pezzi pronti di una taglia su ordinazione: la giacenza
           (oltre, sarebbero pezzi da produrre senza avviso). Le taglie "non vendere" le limita Shopify. */
        var v = V[it.variant_id], max = null;
        if (mto && C.cap > 0) max = C.cap;
        else if (!mto && v && v.t && v.m) max = Math.max(v.q, 0);
        Array.prototype.forEach.call(row.querySelectorAll('[data-quantity-input]'), function (inp) {
          if (max === null) inp.removeAttribute('max'); else inp.setAttribute('max', max);
        });
        /* Al massimo le frecce del browser si fermano senza dire niente: lo si spiega sotto la riga. */
        var limit = row.querySelector('.bn-mto-limit');
        var atMax = max !== null && it.quantity >= max;
        if (atMax) {
          if (!limit) {
            limit = document.createElement('p');
            limit.className = 'bn-mto-limit';
            var after = row.querySelector('.bn-mto-line') || row.querySelector('[data-cart-item-details]') ||
                        row.querySelector('.list-view-item__title');
            if (after) after.insertAdjacentElement('afterend', limit);
          }
          limit.textContent = mto ? T.cap_reached : fill(C.t.ready_limit, { QTY: max });
        } else if (limit) {
          limit.parentNode.removeChild(limit);
        }
      });

      notice.hidden = !hasMto;
      if (!hasMto) error.hidden = true;
      var wallets = root.querySelector('.additional-checkout-buttons');
      if (wallets) wallets.style.display = hasMto ? 'none' : '';
    }

    function refresh() { getCart().then(apply).catch(function () {}); }

    /* Debut ricostruisce le righe a ogni cambio di quantita': si riapplica tutto. */
    var timer = null;
    if (lines && window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 150); })
        .observe(lines, { childList: true, subtree: true });
    }

    /* Quantita' scritta a mano oltre il massimo: si corregge prima che Debut la mandi al carrello
       (la nota sotto la riga spiega il perche'). */
    document.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('[data-quantity-input]') || !root.contains(inp)) return;
      var max = inp.getAttribute('max');
      if (max === null || max === '' || parseInt(inp.value, 10) <= +max) return;
      inp.value = max;
    }, true);

    /* Checkout: con capi su ordinazione la casella e' obbligatoria. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!root.contains(form) || !hasMto || confirmBox.checked) return;
      if (e.submitter && e.submitter.name && e.submitter.name !== 'checkout') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      error.textContent = T.cart_confirm_error;
      error.hidden = false;
      confirmBox.focus();
    }, true);

    refresh();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), initProduct);
    var cartRoot = document.querySelector('[data-section-type="cart-template"]');
    if (cartRoot) initCart(cartRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
